import { hoursToMinutesMap } from './hours-to-minutes-map';
export const getIntervalLengthInMinutes = ({ interval, }) => {
    const isCrossDay = interval.startTime >= interval.endTime;
    if (isCrossDay) {
        return hoursToMinutesMap['24:00'] - (interval.startTime - interval.endTime);
    }
    return interval.endTime - interval.startTime;
};
